/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IActionContext } from '@msdyn365-commerce/core';
import { updateCartLinesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
import { Cart, CartLine } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

import { ICartActionResultWithCart } from './cart-action-result';

export default async function clearCartLineDeliveryMode(
    cart: Readonly<Cart | undefined>,
    cartLineId: string,
    actionContext: IActionContext
): Promise<ICartActionResultWithCart> {
    if (!cart || !cart.CartLines) {
        return { cart: undefined, status: 'FAILED', substatus: 'EMPTYCART' };
    }

    const matchingLines = cart.CartLines.filter(cartLine => cartLine.LineId === cartLineId);

    if (matchingLines.length === 0) {
        return <ICartActionResultWithCart>{ cart: undefined, status: 'FAILED', substatus: 'NOMATCHEDCARTLINE' };
    }

    const copyCartLine: CartLine = { ...matchingLines[0] };

    copyCartLine.DeliveryMode = '';
    copyCartLine.FulfillmentStoreId = '';
    copyCartLine.ShippingAddress = {};
    copyCartLine.WarehouseId = actionContext.requestContext.channel?.InventLocation || cart.WarehouseId;

    return updateCartLinesAsync({ callerContext: actionContext }, cart.Id, [copyCartLine], null)
        .then(newCart => {
            return <ICartActionResultWithCart>{ cart: newCart, status: 'SUCCESS' };
        })
        .catch(error => {
            actionContext.telemetry.warning(error);
            actionContext.telemetry.debug('Unable to Update Cart Line');

            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- existing error type.
            return <ICartActionResultWithCart>{ cart: undefined, status: 'FAILED', errorDetails: { LocalizedMessage: error.message } };
        });
}
